import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
// import TournoiOpen from "../../../assets/img/img-tournois/2026/posterTournoi-2026-422x597.jpg";
// import Badminton from "../../../assets/img/img-badminton/2026/2026-00-imgBad-708x1000.png";
// import bonneAnnee from "../../../assets/img/img-news/bonneAnnee2025-450x300.png";
import assembleeGenerale from "../../../assets/img/img-news/ag/ag-2026-tcf-1055x1491.jpeg";
// import bonneReprise from "../../../assets/img/img-news/Inscriptions/2027_Affiche inscription-1414x2000.png";
// import videoNewYear from "../../../assets/video/bonneAnnee2026.mp4";
// import ReactPlayer from "react-player/lazy";

const Reserve = () => {
  return (
    <>
      <Col
        xs={{ span: 10, offset: 1 }}
        md={{ span: 6, offset: 0 }}
        lg={4}
        className="py-4 px-2"
      >
        <Card className="bg-transparent border-0">
          <Card.Img variant="top" src={assembleeGenerale} alt="..." />
          {/* <Card.Body>
            <Card.Text>
              <em className="fw-bold">
                La saison 2026 de TENNIS redémarre, Bonne reprise à TOUS !!
              </em>
            </Card.Text>
          </Card.Body> */}
          {/* <Card.Body className="text-light mc-rfs-1 fw-bold p-0">
            <ReactPlayer
              // style={{ position: "absolute", top: "0" }}
              url={videoNewYear}
              playing
              muted
              loop
              width="100%"
              height="100%"
            />
          </Card.Body> */}
        </Card>
      </Col>
    </>
  );
};

export default Reserve;
